module.exports = __webpack_public_path__ + "img/ben-industry-hero.83e71efe.svg";